package com.jingfangpai.common.orm.mapping.enums

import org.jooq.ICatalog
import org.jooq.ISchema
import org.jooq.IEnumType
import kotlinx.serialization.Serializable

@Serializable
enum class MedicalRecordPatientSex(private val literal: String) : IEnumType {
	男("男"),
	女("女");
	override fun getCatalog(): ICatalog? {return null}
	override fun getSchema() :ISchema? {return null}
	override fun getName(): String? {return "medical_record_patient_sex"}
	override fun getLiteral(): String {return literal}
}
